export default __webpack_public_path__ + "static/3-a34a4220212da0dedeca17e3ab333bb6.jpeg";